import React from 'react'
import Title from '../../../Common/Title'
import bg from "../../../../Assets/Images/map-platform.png"
import img from "../../../../Assets/Images/_e-img-platform-stats.448717bff4353eedd785_en.png"
import item1 from "../../../../Assets/Images/ic-platform-stats-01@3x.png"
import item2 from "../../../../Assets/Images/ic-platform-stats-02@3x.png"
import item3 from "../../../../Assets/Images/ic-platform-stats-03@3x.png"
import "./styles.scss"

function PlatformMap() {
  return (
    <div className='platformMap'>
        
        <div className="platformMap-bg">
            <img src={bg} alt="" />
        </div>

        <div className="platformMap-container">
        <Title title={<>{`Statistics`}</>} />
        <div className="map">
            <img src={img} alt="" />
        </div>
        <div className="map-list">
          {dataMap.map((item,index) => (
            <div className="item" key={index}>
              <div className="img">
                <img src={item.img} alt="" />
              </div>
              <div className="content2">
                <div className="title">{item.title}</div>
                <div className="detail">{item.detail}</div>
              </div>
            </div>
          ))}
        </div>
        </div>
    </div>
  )
}

export default PlatformMap

const dataMap = [
    {
      img: item1,
      title: 'Statistics that are \neasily recognizable',
      detail: 'Check the overall status \nwith graphs'
    },
    {
      img: item2,
      title: 'Individual Exel files\n',
      detail: 'Download statistical\n data to Excel'
    },
    {
      img: item3,
      title: 'Provides various\n statistics',
      detail: 'By task/category/counselor\nrating/review, etc.'
    },
]